export const stateCodes = [
  // US
  { key: `AL`, value: `Alabama`, group: `USA` },
  { key: `AK`, value: `Alaska`, group: `USA` },
  { key: `AZ`, value: `Arizona`, group: `USA` },
  { key: `AR`, value: `Arkansas`, group: `USA` },
  { key: `CA`, value: `California`, group: `USA` },
  { key: `CO`, value: `Colorado`, group: `USA` },
  { key: `CT`, value: `Connecticut`, group: `USA` },
  { key: `DE`, value: `Delaware`, group: `USA` },
  { key: `FL`, value: `Florida`, group: `USA` },
  { key: `GA`, value: `Georgia`, group: `USA` },
  { key: `HI`, value: `Hawaii`, group: `USA` },
  { key: `ID`, value: `Idaho`, group: `USA` },
  { key: `IL`, value: `Illinois`, group: `USA` },
  { key: `IN`, value: `Indiana`, group: `USA` },
  { key: `IA`, value: `Iowa`, group: `USA` },
  { key: `KS`, value: `Kansas`, group: `USA` },
  { key: `KY`, value: `Kentucky`, group: `USA` },
  { key: `LA`, value: `Louisiana`, group: `USA` },
  { key: `ME`, value: `Maine`, group: `USA` },
  { key: `MD`, value: `Maryland`, group: `USA` },
  { key: `MA`, value: `Massachusetts`, group: `USA` },
  { key: `MI`, value: `Michigan`, group: `USA` },
  { key: `MN`, value: `Minnesota`, group: `USA` },
  { key: `MS`, value: `Mississippi`, group: `USA` },
  { key: `MO`, value: `Missouri`, group: `USA` },
  { key: `MT`, value: `Montana`, group: `USA` },
  { key: `NE`, value: `Nebraska`, group: `USA` },
  { key: `NV`, value: `Nevada`, group: `USA` },
  { key: `NH`, value: `New Hampshire`, group: `USA` },
  { key: `NJ`, value: `New Jersey`, group: `USA` },
  { key: `NM`, value: `New Mexico`, group: `USA` },
  { key: `NY`, value: `New York`, group: `USA` },
  { key: `NC`, value: `North Carolina`, group: `USA` },
  { key: `ND`, value: `North Dakota`, group: `USA` },
  { key: `OH`, value: `Ohio`, group: `USA` },
  { key: `OK`, value: `Oklahoma`, group: `USA` },
  { key: `OR`, value: `Oregon`, group: `USA` },
  { key: `PA`, value: `Pennsylvania`, group: `USA` },
  { key: `RI`, value: `Rhode Island`, group: `USA` },
  { key: `SC`, value: `South Carolina`, group: `USA` },
  { key: `SD`, value: `South Dakota`, group: `USA` },
  { key: `TN`, value: `Tennessee`, group: `USA` },
  { key: `TX`, value: `Texas`, group: `USA` },
  { key: `UT`, value: `Utah`, group: `USA` },
  { key: `VT`, value: `Vermont`, group: `USA` },
  { key: `VA`, value: `Virginia`, group: `USA` },
  { key: `WA`, value: `Washington`, group: `USA` },
  { key: `WV`, value: `West Virginia`, group: `USA` },
  { key: `WI`, value: `Wisconsin`, group: `USA` },
  { key: `WY`, value: `Wyoming`, group: `USA` },
  { key: `DC`, value: `District of Columbia`, group: `USA` },
  { key: `AS`, value: `American Samoa`, group: `USA` },
  { key: `GU`, value: `Guam Outlying area`, group: `USA` },
  { key: `MP`, value: `Northern Mariana `, group: `USA` },
  { key: `PR`, value: `Puerto Rico`, group: `USA` },
  { key: `UM`, value: `Minor Outlying Islands`, group: `USA` },
  { key: `VI`, value: `Virgin Islands`, group: `USA` },
  // AUSTRALIA
  { key: `NSW`, value: `New South Wales`, group: `Australia` },
  { key: `VIC`, value: `Victoria`, group: `Australia` },
  { key: `QLD`, value: `Queensland`, group: `Australia` },
  { key: `WA`, value: `Western Australia`, group: `Australia` },
  { key: `SA`, value: `South Australia`, group: `Australia` },
  { key: `TAS`, value: `Tasmania`, group: `Australia` },
  { key: `ACT`, value: `Australian Capital Territory`, group: `Australia` },
  { key: `NT`, value: `Northern Territory`, group: `Australia` },
];
// USVA , NJ, NY, VA -> GCP
// VA  maxmind
